module.exports = __webpack_public_path__ + "static/media/BD.18068156.png";